import "./Loader.scss"

const mindlerIcon = `${process.env.REACT_APP_MINDLER_PRODUCT_IMAGES_URL}/profile-builder/icons/mindler.png`;

const Loader = () => {
    return (
        <div className="loading-premium">          
            <img className="img-loading" src="https://cdn.taxmann.com/taxmann-images/taxmann-premium/taxmann-premium-loading.gif" alt="" />           
        </div>
    )
}

export default Loader